import axios from "axios";
import CheckHttp from "@/asyncs/MyHttpCheck.js";
import {
    Notify
} from "vant";
import Env from "@/logics/Envs.js";

export default async function (classId, className, studentId, studentName, actor) {
    try {
        const params = { classId, className, studentId, studentName, actor };
        const res = await axios.get(Env.apiPath + "quitClass", { params });
        if (res.data.error) {
            Notify({
                type: "danger",
                message: res.data.error,
                duration: 5000
            });
            return false;
        }
        return true;
    } catch (err) {
        CheckHttp(err);
        return false;
    }
}